var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-message--text" },
    [
      _c(
        "l-map",
        {
          ref: "map",
          staticClass: "map",
          attrs: { center: _vm.message.raw.location, zoom: _vm.zoom },
          on: { ready: _vm.ready, click: _vm.openGoogleMaps },
        },
        [
          _c("l-tile-layer", { attrs: { url: _vm.url } }),
          _vm._v(" "),
          _c("l-marker", {
            attrs: {
              icon: _vm.icons.default,
              "lat-lng": _vm.message.raw.location,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }